import type { JSX } from 'react'
import type { IButtonProps } from '../Button'

import { COLOR } from 'vars/color'
import { INDENTS } from 'vars/indents'
import { Button } from '../Button'
import { ButtonColors, ButtonFonts } from '../Button.h'

export interface IInlinePrimaryBaseTemplateProps extends IButtonProps {
  title: string
  font?: ButtonFonts
  onClick?: IButtonProps['onClick']
}

export const InlinePrimaryBaseTemplate = ({
  title,
  font = ButtonFonts.Button1,
  onClick,
  colorDefault = ButtonColors.COLOR_PRIMARY,
}: IInlinePrimaryBaseTemplateProps): JSX.Element => (
  <Button
    title={title}
    backgroundColorDefault={COLOR.TRANSPARENT}
    colorDefault={colorDefault}
    font={font}
    paddings={[INDENTS.INDENT_0]}
    onClick={onClick}
  />
)
